import React, { useEffect, useState } from "react";
import ArenaLogo from "../../assets/images/ArenaLogoBrandNew.png";
import maacLogo from "../../assets/images/maac-logoBrand.png";
import LakmeLogo from "../../assets/images/LakmeLogoBrand.png";
import aptechAviationLogo from "../../assets/images/aptechAviationLogoBrand.png";
import "react-multi-carousel/lib/styles.css";
import ReactPlayer from "react-player";
import styles from "./studentWorld.module.scss";
import videoPlay from "../../assets/images/play-icon.png";
import AluminiAchievementBanner from "../../assets/images/AluminiAchievementBanner.jpg";
import AluminiAchievementBannerTwo from "../../assets/images/AluminiAchievementBannerTwo.jpg";
import AluminiAchievementBannerThree from "../../assets/images/AluminiAchievementBannerThree.jpg";
import AluminiStory from "../../assets/images/AluminiStory1.jpg";

// New
// import classNames from "classnames";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Icon } from "../../assets/Icons.tsx";
import ArenaVideoImage1 from "../../assets/images/ARENA-1.jpg";
import ArenaVideoImage2 from "../../assets/images/ARENA-2.jpg";
import MaacVideoImg1 from "../../assets/images/MAAC-1.jpg";
import MaacVideoImg2 from "../../assets/images/MAAC-2.jpg";
import LapaVideoImg1 from "../../assets/images/LAPA-1.jpg";
import LapaVideoImg2 from "../../assets/images/LAPA-2.jpg";
import AviationImg1 from "../../assets/images/AVIATION-1.jpg";
import AviationImg2 from "../../assets/images/AVIATION-2.jpg";

const Achievements: React.FC = () => {
  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "Student World", link: "/students-world" },
    { title: "Alumni Achievements", link: "" },
  ];

  return (
    <div className={styles.Achievements}>
      <BreadCrumb menu={breadcrumb} />
      <Banner />
      <AluminiStories />
    </div>
  );
};

export default Achievements;

//Banner section
const Banner: React.FC = () => {
  const [isMobile, setIsMobile] = useState<boolean>(false);
  useEffect(() => {
    const updateView = () => {
      setIsMobile(window.innerWidth < 992);
    };

    updateView();
    window.addEventListener("resize", updateView);

    return () => window.removeEventListener("resize", updateView);
  }, []);
  return (
    <div className="container">
      <div className={`${styles.Banner} section mt-5`}>
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <p className="heading">Alumni Achievements</p>
            <p className="para mt-md-4">
              Students of Aptech have gone on to work with some of the most
              prestigious companies in India and abroad. Many of them have also
              made their own ventures or established themselves as independent
              freelancers in industries like VFX, animation, beauty and wellness, IT, and
              gaming.
            </p>
            <p className="para">
              From <b>media and entertainment </b> to <b>IT, beauty and wellness,</b> and{" "}
              <b>aviation</b>, Aptech alumni have been leaving impeccable
              footprints across industries with their skills, knowledge, and
              potentials. Explore their journeys to see how Aptech has helped
              them turn their dreams into reality.
            </p>
          </div>

          {!isMobile ? (
            <div
              className={`${styles.imageBox} col-xs-12 col-sm-12 col-lg-6 col-md-12 d-flex justify-content-center`}
            >
              <div className={`${styles.imageContainer} mt-0 `}>
                <img
                  src={AluminiAchievementBannerTwo}
                  alt="Back Left"
                  className={styles.backImageLeft}
                />
                <img
                  src={AluminiAchievementBanner}
                  alt="Center"
                  className={styles.centerImage}
                />
                <img
                  src={AluminiAchievementBannerThree}
                  alt="Back Right"
                  className={styles.backImageRight}
                />
              </div>
            </div>
          ) : (
            <div className={`${styles.imageBox} col-12`}>
              <div
                className={`${styles.imageContainer} mt-0 d-flex flex-column `}
              >
                <div className={styles.centerImageBox}>
                  <img
                    src={AluminiAchievementBanner}
                    alt="Center"
                    className={`${styles.centerImageMob} img-fluid`}
                  />
                </div>
                <div className={`${styles.sideImageBox} d-flex`}>
                  <img
                    src={AluminiAchievementBannerThree}
                    alt="Back Right"
                    className={`${styles.backImageRightMob} img-fluid`}
                  />
                  <img
                    src={AluminiAchievementBannerTwo}
                    alt="Back Left"
                    className={`${styles.backImageLeftMob} img-fluid`}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

//Alumini Stories
const AluminiStories: React.FC = () => {
  const [playingVideoId, setPlayingVideoId] = useState<number | null>(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const PrevArrow = ({ onClick }: { onClick?: () => void }) => (
    <div className={styles.prevArrow} onClick={onClick}>
      <Icon name="backArrowIcon" />
    </div>
  );

  const NextArrow = ({ onClick }: { onClick?: () => void }) => (
    <div className={styles.nextArrow} onClick={onClick}>
      <Icon name="forwardArrowIcon" />
    </div>
  );

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };
  const handlePlay = (id: number) => {
    setPlayingVideoId(id);
  };

  interface CardDataMaac {
    id: number;
    text: string;
    video: string;
    content: string;
    thumbnail: string;
  }
  interface CardDataLakme {
    id: number;
    text: string;
    video: string;
    content: string;
    thumbnail: string;
  }
  interface CardDataArena {
    id: number;
    text: string;
    video: string;
    content: string;
    thumbnail: string;
  }
  interface CardDataAviation {
    id: number;
    text: string;
    video: string;
    content: string;
    thumbnail: string;
  }

  const cardDataMaac: CardDataMaac[] = [
    {
      id: 1,
      text: "Video Title",
      video: "https://www.youtube.com/watch?v=-hRFTKVHSSE&t=1s",
      content: `Mandeep Singh Randhawa, a passionate poet and sketch artist, has navigated highs and lows on his career journey. Here's the story of his transition from a MAAC student to an FX Artist.`,
      thumbnail: MaacVideoImg1,
    },
    {
      id: 2,
      text: "Video Title",
      video: "https://www.youtube.com/watch?v=-WMcS_QXBAM",
      content: `MAAC alumnus Sai Tharun talks about his inspiring journey to becoming a Motion Graphics Artist.`,
      thumbnail: MaacVideoImg2,
    },
  ];
  const cardDataLakme: CardDataLakme[] = [
    {
      id: 3,
      text: "Video Title",
      video: "https://www.youtube.com/watch?v=zc8Ae7pMRqc",
      content: `Navpreet began her journey in Beauty and Wellness industry by joining Lakmē Academy Powered by Aptech. Here’s her story that highlights the importance of financial independence.`,
      thumbnail: LapaVideoImg1,
    },
    {
      id: 4,
      text: "Video Title",
      video: "https://www.youtube.com/watch?v=Gsy9GDFNA3c",
      content: `From being a student to a skin trainer at Lakmē Academy, Sushrita's journey is an inspiration to all who wants to make it big in the beauty and wellness industry.  `,
      thumbnail: LapaVideoImg2,
    },
  ];
  const cardDataArena: CardDataArena[] = [
    {
      id: 5,
      text: "Video Title",
      video: "https://youtube.com/shorts/keInr3tMcs4?si=lcQuoywYf7Wtlzdg",
      content: `Watch how Ashutosh transformed his career from a student of designing to a proud entrepreneur of an experiential marketing company.`,
      thumbnail: ArenaVideoImage1,
    },
    {
      id: 6,
      text: "Video Title",
      video: "https://www.youtube.com/watch?v=NK1zWOBzFHU",
      content: `Rakesh tirelessly pursued his vision despite challenges. He is now the proud owner of a flourishing studio where he contributes to the media and entertainment industry. `,
      thumbnail: ArenaVideoImage2,
    },
  ];
  const cardDataAviation: CardDataAviation[] = [
    {
      id: 7,
      text: "Video Title",
      video: "https://www.youtube.com/watch?v=54LWCZDHWH4",
      content: `With the right training in technical and soft skills at Avalon Academy, Mithun KJ got placed as a Ground Staff with Indigo Airlines.`,
      thumbnail: AviationImg1,
    },
    {
      id: 8,
      text: "Video Title",
      video: "https://www.youtube.com/watch?v=lkt0U-mHxEc",
      content: `Our skill-oriented training prepares you for a successful career in the domain of your choice and help you groom your personality as well. 
      Skill-oriented training helped Pranitha R. land a job at Dnata International as a Travel Assistant. Here’s what she has to say about her learning experience at Aptech Aviation. `,
      thumbnail: AviationImg2,
    },
  ];

  const sections = [
    {
      logo: maacLogo,
      name: "(MAAC)",
      cardData: cardDataMaac,
    },
    {
      logo: LakmeLogo,
      name: "(LAPA)",
      cardData: cardDataLakme,
    },
    {
      logo: ArenaLogo,
      name: "(ARENA)",
      cardData: cardDataArena,
    },
    {
      logo: aptechAviationLogo,
      name: "(AVALON ACADEMY)",
      cardData: cardDataAviation,
    },
  ];

  return (
    <div className="container">
      <div className={`${styles.AluminiStories} section`}>
        <div className="row">
          <div className="col-12 col-lg-6 col-md-12">
            <p className="heading">Alumni stories</p>
            <p className="para mt-md-3">
              Here is a showcase of some of the inspiring
              <b> success stories </b>
              of alumni who have made significant progress in their careers
              after completing their courses at Aptech.
            </p>
            <p className="para ">
              Watch these inspiring videos to learn about alumni journeys, their
              achievements, and how Aptech has helped them reach their career
              goals.
            </p>
          </div>
          <div className="col-12 col-lg-6 col-md-12 d-flex justify-content-center mb-3 mt-md-3">
            <img
              src={AluminiStory}
              alt="story"
              className={`${styles.aluminiStoryImg} img-fluid`}
            />
          </div>
        </div>

        {sections.map((section, index) => (
          <div key={index}>
            <div className="row mb-3 mt-md-3 mt-sm-2 ">
              <div className="col-12">
                <img
                  src={section.logo}
                  alt={section.name}
                  className={styles.brandLogo}
                />
                <span className="para fw-bold">{section.name}</span>
              </div>
            </div>

            {isMobile ? (
              <Slider {...sliderSettings} className="mt-2">
                {section.cardData.map((card) => (
                  <div key={card.id} className="mb-4">
                    <div className="ads-slider-card">
                      <div className={styles.playerWrapper}>
                        {playingVideoId !== card.id && (
                          <div
                            className={styles.thumbnail}
                            style={{
                              backgroundImage: `url(${card.thumbnail})`,
                            }}
                          ></div>
                        )}
                        {playingVideoId === card.id && (
                          <div className={styles.reactPlayerWrapper}>
                            <ReactPlayer
                              url={card.video}
                              playing={playingVideoId === card.id}
                              controls={playingVideoId === card.id}
                              width="100%"
                              height="100%"
                              className={styles.reactPlayerDiv}
                            />
                          </div>
                        )}

                        {/* Play button */}
                        {playingVideoId !== card.id && (
                          <div
                            className={styles.playButtonDiv}
                            onClick={() => handlePlay(card.id)}
                          >
                            <img
                              src={videoPlay}
                              alt="Play"
                              className={styles.playButtonImg}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="mt-2 text-center">
                      <p className={`${styles.cardtext} para `}>
                        {card.content}
                      </p>
                    </div>
                  </div>
                ))}
              </Slider>
            ) : (
              <div className="row justify-content-center mt-2">
                {section.cardData.map((card) => (
                  <div className="col-6 mb-5" key={card.id}>
                    <div className="ads-slider-card">
                      <div className={styles.playerWrapper}>
                        {playingVideoId !== card.id && (
                          <div
                            className={styles.thumbnail}
                            style={{
                              backgroundImage: `url(${card.thumbnail})`,
                              backgroundSize: "cover",
                            }}
                          ></div>
                        )}
                        {playingVideoId === card.id && (
                          <div className={styles.reactPlayerWrapper}>
                            <ReactPlayer
                              url={card.video}
                              playing={playingVideoId === card.id}
                              controls={playingVideoId === card.id}
                              width="100%"
                              height="100%"
                              className={styles.reactPlayerDiv}
                            />
                          </div>
                        )}
                        {/* Play button */}
                        {playingVideoId !== card.id && (
                          <div
                            className={styles.playButtonDiv}
                            onClick={() => handlePlay(card.id)}
                          >
                            <img
                              src={videoPlay}
                              alt="Play"
                              className={styles.playButtonImg}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="mt-4">
                      <p className="para mt-4">{card.content}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
